module.exports = __webpack_public_path__ + "assets/img/double_frame.svg";